import React from 'react';
import { List } from 'antd';
import { get, isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import { Retry } from '@components/common';
import { aiAlertsDimensionMappingSelector } from '@store/common/selectors';
import { SectionWrapper, StyledMoreDrawer } from '../styled';
import { StyledList } from './styled';
import Row from './Row';
import { useFetchSummary, useSearchSummary } from './hooks';
import { SkeletonLoader, More } from '../Common';
import { getEndTime, getInsightsWithCauseText } from './utils';

const PREVIEW_LIMIT = 3;
export const MAX_LIMIT = 500;
const product = window.conviva.module || 'EI';

const voidFn = () => null;

function Insights({ openMore = voidFn, closeMore = voidFn, showMore = true }) {
  const to = getEndTime('hour');
  const limit = showMore ? PREVIEW_LIMIT : MAX_LIMIT;

  const { isLoading, isFetching, isError, data, refetch } = useFetchSummary({ to });
  const { insights = [], interval = {}, count = 0 } = get(data, 'data', {});
  const slicedInsights = insights.slice(0, limit);
  const dimensionMapping = useSelector(aiAlertsDimensionMappingSelector);
  const insightsWithCauses = getInsightsWithCauseText(
    slicedInsights,
    dimensionMapping[product.toLocaleLowerCase()],
  );
  const searchSummary = useSearchSummary({ interval, closeMore });

  return (
    <SectionWrapper>
      <Retry
        isLoading={isLoading || isFetching}
        showError={isError}
        isEmpty={isEmpty(insights)}
        mountChildAlways={false}
        fetchData={refetch}
        LoadingLayer={SkeletonLoader}
      >
        <StyledList
          itemLayout="horizontal"
          split={false}
          footer={
            showMore ? <More count={count - slicedInsights.length} onClick={openMore} /> : null
          }
        >
          {insightsWithCauses.map((row) => (
            <List.Item key={row.key}>
              <Row alert={row} searchSummary={searchSummary} />
            </List.Item>
          ))}
        </StyledList>
      </Retry>
    </SectionWrapper>
  );
}

function MoreDrawer({ closeMore, visible }) {
  return (
    <StyledMoreDrawer
      title="Alert Insights"
      placement="right"
      closable
      onClose={closeMore}
      open={visible}
      key="alert-insights-drawer"
      mask
      width={400}
      // destroyOnHidden={true}
    >
      <Insights showMore={false} closeMore={closeMore} />
    </StyledMoreDrawer>
  );
}

export { Insights, MoreDrawer };
